import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

import { env } from '@/shared/config/env'

export const AUTHORITY = `${env.VITE_KEYCLOAK_URL}/realms/${env.VITE_KEYCLOAK_REALM}`

/**
 * Instância em escopo de MÓDULO: criada uma vez por carga de página, imune ao
 * duplo-invoke do StrictMode.
 *
 * (Foi por isto que escolhemos oidc-client-ts e não keycloak-js: aquele é um
 * singleton com `init()` único que lança "can only be initialized once" no
 * duplo-render do React 19, e depende de iframe de check-sso, frágil com
 * cookies de terceiros.)
 *
 * client_id = liberty-finance-front (público, PKCE). O backend valida
 * aud == "liberty-finance" — quem liga os dois é o mapper Audience no realm.
 */
export const userManager = new UserManager({
  authority: AUTHORITY,
  client_id: env.VITE_KEYCLOAK_CLIENT_ID,
  redirect_uri: `${window.location.origin}${env.VITE_KEYCLOAK_REDIRECT_PATH}`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code', // PKCE S256 é o default do oidc-client-ts; o realm suporta
  scope: env.VITE_KEYCLOAK_SCOPE,
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  // Sem iframe → imune a bloqueio de cookie de terceiros. O refresh usa o
  // refresh_token grant, chamada direta ao token endpoint.
  monitorSession: false,
  // O access token já traz tenant_id e roles; userinfo seria um round-trip a mais.
  loadUserInfo: false,
  // sessionStorage e não localStorage: escopo por aba, morre ao fechar. Sem BFF o
  // token é acessível a XSS de qualquer jeito — a mitigação real é CSP estrita.
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
})
